import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'

const EditableButton = Backbone.View.extend({

	/**
	 * Renders a button that displays the selected value
	 * Used for the "set equations" button in scorecards-edit.js, data-source-form.js
	 * and for the "choose criteria" button in transformation-if
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {HTMLElement|JQuery} options.el the element to use
	 *
	 * @param {String} [options.label] an initial label to render
	 *
	 * @param {String} [options.extraClasses] any extra classes to be applied
	 * to the button (e.g. "small" to make a small button)
	 *
	 * @param {String} [options.message='common.choose'] the i18n key for the
	 * default label if no label has been set
	 *
	 * @param {Boolean} [options.escapeLabel=true] indicates whether the label
	 * should be escaped
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	tagName: 'button',

	className: 'button button-default button-nowrap button-right-icon',

	render: function() {
		this.$el.attr('type', 'button')
		this.$el.data('view', this)
		if (this.options.extraClasses) {
			this.$el.addClass(this.options.extraClasses)
		}
		this.renderLabel(this.options.label)
		return this
	},

	/**
	 * Render the a label into the button if one if given, else render the 'choose' verbage
	 * @param {String} val The value to be rendered as a label
	 */
	renderLabel: function(val) {
		let escape = _.isNil(this.options.escapeLabel) ?
			true : this.options.escapeLabel
		let message = _.get(this.options, 'message', 'common.choose')
		var label = i18n.get(message)
		var hasLabel = !_.isNil(val) && val.length > 0 &&
			// if it's a dataset equation, don't display that
			!_.startsWith(val, '{')
		if (hasLabel) {
			label = escape ? _.escape(val) : val
		}
		this.$el.html(label)
			.toggleClass('has-equation', hasLabel)
			.append(icon('edit', 'icon-edit'))
	}

})

export default EditableButton

EditableButton.__filename__ = 'components/editable-button.js'
